export const MIN_WIDTH = 320;
export const MAX_WIDTH = 500;
export const Z_INDEX_DIALOG = 1400;